import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

// Web3Forms Access Key - Replace with your own key from https://web3forms.com
const WEB3FORMS_ACCESS_KEY = "ec5501a3-3d8d-4fa0-9890-606245db809d";
export const Contact = (props) => {
  const [{ name, email, phone, message }, setState] = useState(initialState);
  const [data, setData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = {
      access_key: WEB3FORMS_ACCESS_KEY,
      name: name,
      email: email,
      phone: phone,
      message: message,
      subject: `New Contact Form Submission from ${name}`,
      from_name: "Rudra Surgical Website",
      website: "rudrasurgical.co.in",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus({
          type: "success",
          message: "Thank you for contacting us! We'll get back to you soon.",
        });
        addDataToExcel();
        clearState();

        // Clear success message after 5 seconds
        setTimeout(() => {
          setSubmitStatus(null);
        }, 5000);
      } else {
        setSubmitStatus({
          type: "error",
          message: "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setSubmitStatus({
        type: "error",
        message: "Network error. Please check your connection and try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const addDataToExcel = () => {
    const newData = [...data, { name, email, phone, message }];
    setData(newData);
    localStorage.setItem("excelData", JSON.stringify(newData));
  };

  const redirectToGoogleMaps = (lat, lng) => {
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        value={name}
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        value={email}
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        value={phone}
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Phone Number (e.g., +91 9099093987)"
                        required
                        pattern="[+]?[0-9]{10,14}"
                        title="Please enter a valid phone number"
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    value={message}
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                {/* Status Messages */}
                {submitStatus && (
                  <div
                    className={`alert ${
                      submitStatus.type === "success"
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                    style={{
                      marginTop: "15px",
                      padding: "10px 15px",
                      borderRadius: "4px",
                    }}
                  >
                    {submitStatus.message}
                  </div>
                )}

                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={isSubmitting}
                  style={{
                    opacity: isSubmitting ? 0.7 : 1,
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
                <br />
                {props.data ? props.data.phone2 : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.whatsapp : "/"}>
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        redirectToGoogleMaps(
                          21.238637775993826,
                          72.8708690864455,
                        )
                      }
                    >
                      <i className="fa fa-map-marker"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Button Section */}
      {/* <div
        style={{
          textAlign: "center",
          padding: "40px 0",
          backgroundColor: "#f6f6f6",
        }}
      >
        <h3 style={{ marginBottom: "20px", color: "#333" }}>Find Us on Map</h3>
        <button
          className="btn btn-custom btn-lg"
          onClick={() =>
            redirectToGoogleMaps(21.238637775993826, 72.8708690864455)
          }
          style={{ margin: "10px" }}
        >
          <i className="fa fa-map-marker" style={{ marginRight: "8px" }}></i>
          Open in Google Maps
        </button>
      </div> */}

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} <b>Rudra Surgical</b>
            <br /> Design by{" "}
            <a href="https://deltaryn.com/" rel="nofollow">
              Deltaryn System
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
